<template>
  <v-select
    v-model="selectedSiteLocationId"
    :items="siteLocations"
    item-title="name"
    item-value="id"
    label="Site Location"
    variant="outlined"
    density="compact"
    hide-details
    :loading="isLoadingSiteLocations"
    @update:model-value="handleSiteLocationChange"
  />
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import API from '@/Core.Service.Domain/Devices/Devices.Common/API/index.ts';

const selectedSiteLocationId = ref<number | string | null>(null);
const siteLocations = ref<Array<{ id: number; name: string }>>([]);
const isLoadingSiteLocations = ref(false);

const props = defineProps({
  siteId: {
    type: [Number, String],
    required: true,
  },
  modelValue: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: number | string): void;
}>();

const fetchSiteLocations = async () => {
  isLoadingSiteLocations.value = true;
  try {
    const response = await API.getSiteLocationsForSiteId(props.siteId);
    siteLocations.value = response;
    if (props.modelValue) {
      selectedSiteLocationId.value = props.modelValue;
    }
  } catch (error) {
    console.error('Error fetching site locations:', error);
  } finally {
    isLoadingSiteLocations.value = false;
  }
};

const handleSiteLocationChange = (value: number | string) => {
  emit('update:modelValue', value);
};

onMounted(() => {
  fetchSiteLocations();
});
</script>
